<template>
  <eye-exam-card
    class="medical-record-exam-view"
    title="Paquimetria"
    :patient-id="patientId"
    :record-id="recordId"
    :exam-id="examId"
    :inputs="data"
    :rows-definition="table.body"
    :date="date"
    @edit="$emit('edit')"
    :show-edit-button="showEditButton"
  />
</template>

<script>
import formatters from '@/filters';
import EyeExamCard from '../ophtalmology/EyeExamCard.vue';

export default {
  name: 'PachymetryView',
  components: {
    EyeExamCard,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    patientId: {
      type: String,
      required: false,
    },
    recordId: {
      type: String,
      required: false,
    },
    examId: {
      type: String,
      required: false,
    },
    date: {
      type: String,
      required: false,
    },
    showEditButton: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      table: {
        body: [
          {
            label: 'Paquimetria',
            R: 'valueR',
            L: 'valueL',
            formatter: formatters.micron,
          },
        ],
      },
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables";
</style>
